import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ReactPlugin } from '@microsoft/applicationinsights-react-js'
import { createBrowserHistory } from 'history'
import { getHopSkipConfig } from './auth.config'

const browserHistory = createBrowserHistory()
const reactPlugin = new ReactPlugin()

const hopSkipConfig = getHopSkipConfig()

const appInsights = new ApplicationInsights({
	config: {
		connectionString: hopSkipConfig.appInsights.connectionString,
		maxBatchInterval: 500,
		disableFetchTracking: false,
		correlationHeaderDomains: ['*.myhopskip.com'],
		enableCorsCorrelation: true,
		extensions: [reactPlugin],
		extensionConfig: {
			[reactPlugin.identifier]: {
				history: browserHistory
			}
		}
	}
})

appInsights.loadAppInsights()
appInsights.trackPageView()

export { reactPlugin, appInsights }
